export function getLeaveStatusOptions(process) {
  if (!process) return []
  const values = Array.isArray(process.leaveStatusOptions)
    ? process.leaveStatusOptions
    : String(process.leaveStatus || '').replace(/，/g, ',').split(',')
  return [...new Set(values.map(value => String(value).trim()).filter(Boolean))]
}
